<template>
  <div id="download">
    <div class="ui text container">
      <h2 class="ui header">件名：{{title}}</h2>
      <h4 class="ui top attached block header">送信者からのコメント</h4>
      <div class="ui bottom attached segment newline-wrap">{{comments}}</div>
      <table class="ui table" id="receiverList-fileTable">
        <thead>
          <tr class="single line">
            <th width="30px">No.</th>
            <th>ファイル名</th>
            <th width="200px">操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in items" :key="index">
            <td class="receiverList-fileTable_no">{{index + 1}}</td>
            <td class="receiverList-fileTable_fileName newline-wrap">{{item.file_name}}</td>
            <td class="receiverList-fileTable__operation">
              <button
                class="ui button blue tiny receiverList-fileTable__download"
                @click="downloadFile(item.file_name, item.download_url)"
              >ダウンロード</button>
            </td>
          </tr>
        </tbody>
      </table>
      <table id="receiverList-duration" class="ui very basic table">
        <tbody>
          <tr>
            <td class="right aligned receiverList-duration__upload">アップロード日時：</td>
            <td>{{uploadedDate | datetime}}</td>
          </tr>
          <tr>
            <td class="right aligned receiverList-duration__expiration">ダウンロード期限：</td>
            <td>{{expireDate | datetime}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { downloadFile } from '@/api'

export default {
  title: 'ダウンロードファイル一覧',
  data: function () {
    return {
      items: [],
      title: '-',
      expireDate: '',
      uploadedDate: '',
      comments: '-'
    }
  },
  created: function () {
    this.$store.commit('progress/setLoading', true)
    const downloadFiles = this.$store.state.receiver.files
    this.$store.commit('progress/setLoading', false)
    if (!downloadFiles) {
      this.$router.push({ name: 'receiverDownloadLogin' })
    } else {
      this.title = this.$store.state.receiver.title
      this.expireDate = this.$store.state.receiver.expireDate
      this.uploadedDate = this.$store.state.receiver.uploadedDate
      this.comments = this.$store.state.receiver.comments
      this.items = downloadFiles
    }
  },
  methods: {
    /** ファイルをダウンロードする */
    downloadFile: function (fileName, downloadUrl) {
      this.$store.commit('progress/setLoading', true)

      downloadFile(downloadUrl)
        .then(response => {
          this.$store.commit('progress/setLoading', false)
          if (window.navigator.msSaveOrOpenBlob) {
            /* IEの場合 */
            navigator.msSaveBlob(new Blob([response.data]), fileName)
          } else {
            /* IE以外(Chrome, Firefox) */
            const link = document.createElement('a')
            link.setAttribute('href', window.URL.createObjectURL(new Blob([response.data])))
            link.setAttribute('download', fileName)
            document.body.appendChild(link)
            link.click()
            link.remove()
          }
        })
        .catch(err => {
          console.log(err)
          this.$store.commit('progress/setLoading', false)

          if (err.response.status === 403) {
            this.$store.commit('infoModal/openModal', {
              type: 'ERROR',
              title: 'ログインタイムアウト',
              message: 'ログインタイムアウトになりました。\n再度ログインをして、操作し直してください。',
              btnLabel: 'OK',
              callback: () => {
                this.$router.push({ name: 'receiverDownloadLogin' })
              }
            })
          } else {
            this.$store.commit('infoModal/openModal', {
              type: 'ERROR',
              title: 'ファイルダウンロード',
              message: '通信エラーが発生しました。\nしばらくしてからもう一度お試しください。'
            })
          }
        })
    }
  }
}
</script>

<style>
#download {
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
}

.item-title {
  font-weight: bolder;
  text-align: end;
}
</style>
